export default __webpack_public_path__ + "static/media/producto-12.97f9e24a.jpg";